import React from "react";
import { Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";

const ArchivedClient = props => {
  const { archived, myType, onToggleArchivedDeadline } = props;

  return (
    myType !== "STUDIO" && (
      <div>
        <Tooltip
          placement={archived ? "topLeft" : "bottomLeft"}
          color={"rgb(0, 80, 117)"}
          title={
            !archived ? (
              <div style={{ padding: "10px" }}>
                <div style={{ fontWeight: "bold", paddingBottom: "5px" }}>
                  <FormattedMessage id="deadlines.hideDeadline" />
                </div>
                <div style={{ fontSize: "12px" }}>
                  <FormattedMessage id="deadlines.pages.detail.hiddenDeadlineDetail" />
                </div>
              </div>
            ) : (
              <FormattedMessage id="deadlines.showDeadline" />
            )
          }
          onClick={onToggleArchivedDeadline}
        >
          <FontAwesomeIcon
            icon={["fas", archived ? "plus-square" : "minus-square"]}
            style={{ fontSize: 22, color: "#0090d1" }}
          />
        </Tooltip>
      </div>
    )
  );
};
export default ArchivedClient;
